import { render } from "./ProductToPriceGroups.vue?vue&type=template&id=cdda2784&ts=true"
import script from "./ProductToPriceGroups.vue?vue&type=script&lang=ts"
export * from "./ProductToPriceGroups.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__